<template>
  <div
    class="panel-component-container"
    :class="{ 'half-size': halfSize}"
  >
    <div class="heading">
      <icon
        :name="icon"
        variant="516173"
      />
      <span>{{ heading }}</span>
      <button
        v-if="collapsible"
        class="collapse-btn"
        :class="{ 'collapsed': collapsed }"
        @click="toggleCollapsed(!collapsed)"
      >
        <icon
          name="arrow-down"
          variant="a8aab7"
        />
      </button>
      <button
        v-if="info"
        class="info-btn"
        @click="$emit('info-btn-clicked')"
      >
        <icon
          name="info-outline"
          variant="546171"
        />
      </button>
    </div>
    <transition name="slide">
      <div
        v-if="!collapsed"
        key="div"
        class="content"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  props: {
    collapsible: {
      type: Boolean,
      default: false,
    },
    halfSize: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'info',
    },
    info: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collapsed: false,
    };
  },
  mounted() {
    // Start out collapsed if collapsible
    if (this.collapsible) {
      this.collapsed = true;
    }
  },
  methods: {
    toggleCollapsed(val) {
      this.collapsed = val;
    },
  },
};
</script>

<style lang='scss' scoped>
  .panel-component-container {
    background: white;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,0.25);
    border-radius: 4px;

    .heading {
      align-items: center;
      background-image: linear-gradient(to top, #f2f4f7, #ffffff);
      border-radius: (rem-calc(4) rem-calc(4) 0 0);
      display: flex;
      padding: rem-calc(12);

      span {
        color: #516173;
        font-size: rem-calc(10);
        font-weight: $semi-bold;
        letter-spacing: rem-calc(1);
        margin-left: rem-calc(8);
        text-transform: uppercase;
      }

      /deep/ img {
        height: rem-calc(16);
        width: rem-calc(16);
      }

      .collapse-btn {
        display: inline-block;
        height: rem-calc(20);
        width: rem-calc(20);
        margin-left: auto;
        background-color: #e9edf1;
        border: solid 1px rgba(0,0,0,0.1);
        padding: 0;

        img {
          width: rem-calc(8);
          margin: rem-calc(2) rem-calc(5);
          transform: initial;
          transition: .2s all ease;
        }

        &:not(.collapsed) img {
          transform: rotate(180deg);
        }
      }
      .info-btn {
        display: inline-block;
        height: rem-calc(16);
        width: rem-calc(16);
        padding: 0;
        background-color: transparent;
        margin-left: auto;
      }
    }

    .slide-enter-active {
      transition: all .1s ease;
    }

    .slide-enter,
    .slide-leave {
      transform: translateY(-10px);
    }

    .content {
      color: #354052;
      padding: rem-calc(16);
      position: relative;
    }
  }
  .half-size {
    width: 49%;

    @include breakpoint(medium) {
      width: 100%;
      &:first-of-type {
        margin-bottom: 1rem;
      }
    }
  }
</style>
